import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import InputsUser from "./InputsUser";

export default function DisplayManyUsers({
                                             obj, setObj,
                                             setBlockSubmit, name,
                                             type, isFundo
                                         }) {

    const addComponent = () => {
        const index = obj.length
        setObj([...obj, {index, papel: type}]);
    };

    const removeComponent = (index) => {
        if (obj.length > 1) {
            const updatedComponents = [...obj];
            updatedComponents.splice(index, 1);
            setObj(updatedComponents);
        }
    };

    const alterItem = (index, data) => {
        setObj((prevComponents) => {
            const updatedComponents = [...prevComponents];
            updatedComponents[index] = data;
            return updatedComponents;
        });
    };

    return (
        <div>
            {obj.map((componentData, index) => (
                <div key={index}>
                    {/*{index !== 0 && <hr/>}*/}
                    <>
                        <Box mb={0.5} pb={0.5}>
                            {name} {index + 1}

                            {obj.length > 1 && index !== 0 &&
                                <div
                                    className='d-inline text-danger'
                                    style={{cursor: 'pointer'}}
                                    onClick={() => removeComponent(index)}
                                >
                                    &nbsp; Remover
                                </div>
                            }
                        </Box>
                    </>
                    {isFundo ?
                        <InputsUser
                            obj={componentData}
                            setObj={(newData) => {
                                alterItem(index, newData);
                            }}
                            index={index}
                            isFundo={true}
                            setBlockSubmit={setBlockSubmit}
                            type={type}
                        />
                    :
                        <InputsUser
                            isFundo={false}
                            obj={componentData}
                            setObj={(newData) => {
                                alterItem(index, newData);
                            }}
                            index={index}
                            type={type}
                            setBlockSubmit={setBlockSubmit}
                        />
                    }

                </div>
            ))}
            <Button fullWidth onClick={addComponent} type='button'>Adicionar mais um {name} </Button>
        </div>
    );
}